export default __webpack_public_path__ + "static/media/empty_upload.4bf9d92c.svg";